module.exports = __webpack_public_path__ + "static/media/xiangyangshanadj.a6d2fcdd.png";